export default class AttributeParser {
    static parseBooleanAttribute(text) {
        if (typeof text === 'undefined') return false;
        if (text === null) return false;

        if (typeof text === 'string') {
            text = text.toLowerCase();
        }

        if (text === 'true') return true;
        if (text === 'yes') return true;
        if (text === '1') return true;

        if (text === 'false') return false;
        if (text === 'no') return false;
        if (text === '0') return false;

        // Otherwise do truthy conversion
        return !!text;
    }
}